import React from "react";
import { Link } from "react-router-dom";

function PublicLayout({ children }) {
  return (
    <div className="min-h-screen overflow-y-auto flex flex-col bg-gray-50">
      <header className="bg-white shadow-sm p-4">
        <div className="max-w-7xl mx-auto flex items-center justify-center space-x-4">
          <Link to={"https://www.whereiszuba.com/home"} className="flex items-center space-x-2">
            <div className="w-12 h-12 bg-gray-300 rounded">
              <img
                src={require("../../assets/logo/zuba-logo.png")}
                alt="ZUBA Logo"
                className="w-full h-full object-cover rounded"
              />
            </div>
            <h1 className="text-xl font-semibold text-gray-900">ZUBA</h1>
          </Link>
        </div>
      </header>
      <main className="overflow-y-auto flex-grow max-w-7xl mx-auto  p-6 w-full">{children}</main>
      <footer className="bg-white shadow-inner p-4 text-center text-sm text-gray-500">
        &copy; {new Date().getFullYear()} ZUBA. All rights reserved.
      </footer>
    </div>
  );
}

export default PublicLayout;
